import { useSearchParam } from "lib/@hooks/use-search-param"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { useState } from "react"
import { Bound } from "lib/@components/binding/Bound"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { getTailoredSchedules } from "routes/asset-register/plugins/general-tailoring/controller/get-tailored-schedules"
import { RequestPageRepeat } from "lib/@components/request-page-repeat"
import { TailoredSchedule } from "routes/asset-register/plugins/general-tailoring/tailored-schedule"
import { Box, Container, List, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import { useReferenceState } from "lib/@hooks/use-reference"
import { ListItemBox } from "lib/@components/ListItemBox"
import { PageSize } from "lib/@components/pagination/page-size"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import { setFromValueParam } from "lib/setFromEvent"
import { PaginationPortal } from "lib/@components/pagination-portal"
import { FitInRemainingSpace } from "lib/@components/fit-in-remaining-space"
import { createSlot } from "lib/@components/slot/create-slot"

const noResults = Object.freeze({ items: [], totalCount: -1 })

export const TailoredSchedulesRegimeTabWrapper = createSlot("TailoredSchedulesRegimeTabWrapper")

export function TailoredSchedulesRegimeTab({ prefix = "" }) {
    const [search] = useSearchParam("search")
    const [filters, setFilters] = useState([])
    const [skip, setSkip] = useState(0)
    const [take, setTake] = useReferenceState("tailored-page-size", 10)
    const { parentItem } = useBoundContext()

    const regime = parentFind(parentItem, (c) => c[PlanRoot])
    const regimeId = regime?.id

    const generalTailored =
        getTailoredSchedules.useResults({ regimeId: `${prefix}${regimeId}`, take, skip, search, filters }) ?? noResults

    return generalTailored?.totalCount === -1 ? (
        <LoadingScreen />
    ) : (
        <Bound regime={regime} regimeId={regimeId} filters={filters}>
            <TailoredSchedulesRegimeTabWrapper.Wrapper>
                <Container>
                    <List dense>
                        <SearchBoxUsingSearchParam />
                        <ListItemBox spacing={1} mb={1}>
                            <Typography variant="caption">Filters</Typography>
                            <ToggleButtonGroup
                                color="primary"
                                size="small"
                                value={filters}
                                onChange={setFromValueParam(setFilters)}
                            >
                                <ToggleButton value="Excluded" data-cy="excluded-filter-tab">
                                    Excluded
                                </ToggleButton>
                                <ToggleButton value="Classification" data-cy="criticality-filter-tab">
                                    Criticality
                                </ToggleButton>
                                <ToggleButton value="Duration" data-cy="duration-filter-tab">
                                    Duration
                                </ToggleButton>
                                <ToggleButton value="Frequency" data-cy="frequency-filter-tab">
                                    Frequency
                                </ToggleButton>
                                <ToggleButton value="SkillSet" data-cy="skill-filter-tab">
                                    Skill
                                </ToggleButton>
                                <ToggleButton value="RedTasks" data-cy="sfg20-red-filter-tab">
                                    SFG20 Red
                                </ToggleButton>
                                <ToggleButton value="AmberTasks" data-cy="sfg20-amber-filter-tab">
                                    SFG20 Amber
                                </ToggleButton>
                            </ToggleButtonGroup>
                            <Box flex={1} />
                            <PageSize take={take} setTake={setTake} />
                            <PaginationPortal />
                        </ListItemBox>
                        <FitInRemainingSpace leaveSpace={24}>
                            <RequestPageRepeat
                                pageSize={take}
                                total={generalTailored.totalCount}
                                list={generalTailored?.items ?? []}
                                setTake={setTake}
                                setSkip={setSkip}
                                item={<TailoredSchedule />}
                                keyFn={(v) => v.id}
                                refreshKey={search}
                            />
                        </FitInRemainingSpace>
                    </List>
                </Container>
            </TailoredSchedulesRegimeTabWrapper.Wrapper>
        </Bound>
    )
}
